module.exports = __webpack_public_path__ + "img/addressEle.8bc08f78.svg";